// src/components/Layout.js
import React from "react";
import { Link } from "react-router-dom";

export default function Layout({ children }) {
  return (
    <div
      style={{
        backgroundColor: "#1E2A38",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='192' height='192' viewBox='0 0 192 192'%3E%3Cpath fill='%239C92AC' fill-opacity='1' d='...")`,
        backgroundRepeat: "repeat",
        backgroundSize: "100px 100px",
        fontFamily: "Arial, sans-serif",
        color: "#1E2A38",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <header
        style={{
          backgroundColor: "#1E2A38",
          color: "#fff",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap"
        }}
      >
        <h2 style={{ margin: 0 }}>Benjamin Hoch Coaching</h2>
        <nav style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
          <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>Home</Link>
          <Link to="/about" style={{ color: "#fff", textDecoration: "none" }}>About</Link>
          <Link to="/blog" style={{ color: "#fff", textDecoration: "none" }}>Blog</Link>
          <Link to="/contact" style={{ color: "#fff", textDecoration: "none" }}>Contact</Link>
        </nav>
      </header>

      <main style={{ flex: 1, padding: "2rem", textAlign: "center" }}>
        {children}
      </main>

      <footer
        style={{
          backgroundColor: "#1E2A38",
          color: "#fff",
          textAlign: "center",
          padding: "1rem"
        }}
      >
        <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} Benjamin Hoch Coaching</p>
      </footer>
    </div>
  );
}
